import { createSettingsParams } from '@wix/tpa-settings';

import applicationJson from '../../../.application.json';

export const pluginsKeys: (keyof ISettingBooleanParam)[] = [
  'PluginAI',
  'PluginToc',
  'HeadingsPlugin',
  'ImagePlugin',
  'VideoPlugin',
  'AudioPlugin',
  'GalleryPlugin',
  'FilePlugin',
  'DividerPlugin',
  'ButtonPlugin',
  'GifPlugin',
  'CodeBlockPlugin',
  'EmojiPlugin',
  'EmbedPlugin',
  'TextColorPlugin',
  'TextHighlightColorPlugin',
  'CollapsibleListPlugin',
  'TablePlugin',
  'SpoilerPlugin',

  // social
  'SocialPlugin',
  'SoundcloudPlugin',
  'PollPlugin',

  // experimental
  'VerticalEmbed',
  'ActionButtonPlugin',
];

type ISettingBooleanParam = {
  showDebugHeader: boolean;
  showImportExport: boolean;
  useNewPluginMenu: boolean;
  useFontSize: boolean;
  useStickyToolbar: boolean;
  useFileUploadSizeLimit: boolean;

  // plugins
  ImagePlugin: boolean;
  VideoPlugin: boolean;
  AudioPlugin: boolean;
  HeadingsPlugin: boolean;
  GalleryPlugin: boolean;
  FilePlugin: boolean;
  DividerPlugin: boolean;
  ButtonPlugin: boolean;
  GifPlugin: boolean;
  CodeBlockPlugin: boolean;
  EmojiPlugin: boolean;
  EmbedPlugin: boolean;
  TextColorPlugin: boolean;
  TextHighlightColorPlugin: boolean;
  SpoilerPlugin: boolean;

  // social
  SocialPlugin: boolean;
  SoundcloudPlugin: boolean;
  PollPlugin: boolean;

  // experimental
  VerticalEmbed: boolean;
  CollapsibleListPlugin: boolean;
  ActionButtonPlugin: boolean;
  TablePlugin: boolean;
  PluginAI: boolean;
  PluginToc: boolean;

  useLinkToSection: boolean;
  useVerticalSlimLayout: boolean;
  clickToTweet: boolean;
};

export type ISettingsParams = ISettingBooleanParam & {
  greetingsText: string;
};

export default createSettingsParams<ISettingsParams>({
  greetingsText: {
    getDefaultValue: ({ t }) =>
      `${t('app.settings.defaults.greetingsPretext')} ${
        applicationJson.appName
      }`,
  },

  showDebugHeader: {
    getDefaultValue: () => true,
  },

  showImportExport: {
    getDefaultValue: () => true,
  },

  useNewPluginMenu: { getDefaultValue: () => true },
  useStickyToolbar: { getDefaultValue: () => false },
  useFontSize: { getDefaultValue: () => true },
  HeadingsPlugin: { getDefaultValue: () => true },
  ImagePlugin: { getDefaultValue: () => true },
  VideoPlugin: { getDefaultValue: () => true },
  AudioPlugin: { getDefaultValue: () => true },
  GalleryPlugin: { getDefaultValue: () => true },
  FilePlugin: { getDefaultValue: () => true },
  DividerPlugin: { getDefaultValue: () => true },
  ButtonPlugin: { getDefaultValue: () => true },
  GifPlugin: { getDefaultValue: () => true },
  CodeBlockPlugin: { getDefaultValue: () => true },
  EmojiPlugin: { getDefaultValue: () => true },
  EmbedPlugin: { getDefaultValue: () => true },
  TextColorPlugin: { getDefaultValue: () => true },
  TextHighlightColorPlugin: { getDefaultValue: () => true },
  CollapsibleListPlugin: { getDefaultValue: () => true },
  TablePlugin: { getDefaultValue: () => true },
  SpoilerPlugin: { getDefaultValue: () => true },
  useFileUploadSizeLimit: { getDefaultValue: () => false },

  // social
  SocialPlugin: { getDefaultValue: () => true },
  SoundcloudPlugin: { getDefaultValue: () => true },
  PollPlugin: { getDefaultValue: () => false },

  // experimental
  VerticalEmbed: { getDefaultValue: () => true },
  PluginAI: { getDefaultValue: () => true },
  PluginToc: { getDefaultValue: () => true },
  ActionButtonPlugin: { getDefaultValue: () => false },
  useLinkToSection: { getDefaultValue: () => true },
  useVerticalSlimLayout: { getDefaultValue: () => false },
  clickToTweet: { getDefaultValue: () => false },
});
